module.exports = __webpack_public_path__ + "img/cover_corona_texto_branco.d99f1086.png";